var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    x: 0.75,
    y: 0.75,
    width: 20.5,
    height: 18.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "currentColor",
    d: "M0 5h22v1.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.5,
    fill: "currentColor",
    d: "M7 9.533L4.143 12.2 7 14.867l-.571.533L3 12.2 6.429 9zM15 9.533l2.857 2.666L15 14.867l.571.533L19 12.2 15.571 9zM12.104 8.606l.906.423-3.17 6.797-.906-.423z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevTools);
export default __webpack_public_path__ + "static/media/DevTools.17be7fb4.svg";
export { ForwardRef as ReactComponent };